import { render, staticRenderFns } from "./smsDeposit.vue?vue&type=template&id=f1abe5e2&scoped=true&"
import script from "./smsDeposit.vue?vue&type=script&lang=js&"
export * from "./smsDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1abe5e2",
  null
  
)

export default component.exports